import { useAppDispatch } from "@hooks/useTypedRedux";
import { openModal } from "@features/modals/genericModalSlice";
import { ConfirmationModal } from "@features/modals/ConfirmationModal";
import { PendingFormDataToAssignPerPatient } from "@features/formAssignments/patientInfoAndFormsPage/forms/usePendingFormDataToAssign";
import useAssignFormsAndSendToDottlink from "./useAssignFormsAndSendToDottlink";
import { Typography } from "@mui/material";
import { FormModalStyles } from "@features/modals/FormModalStyles";

function useOnAssignForms() {
  const dispatch = useAppDispatch();
  const { assignFormsAndSendToDottlink, isLoading } =
    useAssignFormsAndSendToDottlink();

  const onAssignForms = (
    pendingFormDataToAssign: PendingFormDataToAssignPerPatient
  ): void => {
    const familyMembersWithoutForms = Object.values(pendingFormDataToAssign)
      .filter(({ incompleteForms }) => incompleteForms.length === 0)
      .map(({ inOfficeEvent }) => inOfficeEvent.patient)
      .sort((a, b) => a.firstName.localeCompare(b.firstName));

    if (familyMembersWithoutForms.length === 0) {
      assignFormsAndSendToDottlink(pendingFormDataToAssign);
      return;
    }

    dispatch(
      openModal({
        component: ConfirmationModal,
        props: {
          title: "Family Check",
          body: (
            <>
              <Typography sx={FormModalStyles.script}>
                It looks like multiple family members are here and you
                haven&apos;t assigned forms to the patients below.
              </Typography>
              {familyMembersWithoutForms.map((patient) => (
                <Typography key={patient.id} sx={FormModalStyles.description}>
                  - {patient.firstName}
                </Typography>
              ))}
              <Typography sx={FormModalStyles.script}>
                Are you sure you don&apos;t want to assign forms to these
                patients?
              </Typography>
            </>
          ),
          confirmLabel: "Yes, Send",
          cancelLabel: "No, Go Back",
          onConfirm: () =>
            assignFormsAndSendToDottlink(pendingFormDataToAssign),
        },
      })
    );
  };

  return {
    onAssignForms,
    isLoading,
  };
}

export default useOnAssignForms;
